export const financeTabsArticle = {
  title: 'Finance Command Center: Tabs & Data',
  slug: 'finance-tabs',
  content: `Finance Command Center: Tabs & Data

Navigate the Finance Hub to track revenue health.

1) Transactions
- Log revenue and expenses.

2) Dashboard
- Review KPIs and summaries for the selected period.

3) Insights
- Surface trends and potential anomalies.

Tip
- Use URL hashes (#transactions, #dashboard, #insights) to deep-link tabs.
`,
};
